export const container ="px-4 md:mt-12 md:px-9 mb-20"
export const bannerContainer ="relative w-full  bg-cover bg-center mt-4 flex items-center text-white rounded-md pl-4 md:pl-8"
export const banner ="flex flex-col justify-center  md:w-full my-16"
export const bannerTitle ="text-2xl md:text-5xl font-normal"
export const bannersubtitle ="md:w-4/5 my-4"
export const bannersubtitleTxt ="text-sm md:text-md"
export const bannerButtonContainer = "w-2/3 md:w-1/3 pr-4"
export const getStartedContainer = "mt-8 py-2"
export const welcomeMessage= "text-3xl"
export const welcomeText= "text-sm font-thin"
export const bannerButton = "bg-custom-button-green text-black rounded-none"
export const gridContainer = 'grid grid-cols-1 md:grid-cols-2 gap-6';
export const marginTop = 'mt-4';